import React from "react";

import { TableColumnTitle } from "./table-column-title";
import { TableColumn } from "../../../../../../models";

interface TableColumnsRowProps {
  columns: Array<TableColumn>;
  isDrawPrintIcon?: boolean;
  isDrawJackpot?: boolean;
}

export const TableColumnsRow: React.FC<TableColumnsRowProps> = ({
  columns,
  isDrawPrintIcon,
  isDrawJackpot,
}) => {
  return (
    <div className="main-table-head">
      <div className="main-table-row">
        {columns.map(({ title, dataKey, hideColumn }) =>
          !hideColumn ? <TableColumnTitle key={dataKey} value={title} /> : null,
        )}
        {isDrawPrintIcon ? (
          <div className="table-inner-item table-print-item" />
        ) : null}

        {isDrawJackpot ? (
          <div className="table-inner-item table-print-item" />
        ) : null}
      </div>
    </div>
  );
};
